import IconImage from "../../../Common/Icons/IconImage";
import IconTick from "../../../Common/Icons/IconTick";
import { FormState } from "../../state";
import { UploadedImageCard } from "./UploadedImageCard";

interface EngagementPanelOptionInterface {
  checked: boolean;
  optionFile?: File;
  type: FormState["type"];
  onClick: () => void;
  handleOptionChange?: any;
  handleOptionFileChange?: any;
  defaultValue?: string;
}

export default function EngagementPanelOption(
  props: EngagementPanelOptionInterface
) {
  return (
    <div
      className={`rounded-xl border-solid border-2 border-brij-LightGrey bg-brij-White flex flex-col items-center justify-start overflow-clip h-[120px]`}
    >
      <div
        className={`w-full flex flex-row justify-between p-2 ${
          props.optionFile && "h-full"
        }`}
      >
        {props.optionFile ? (
          <>
            <UploadedImageCard
              file={props.optionFile}
              handleFileChange={props.handleOptionFileChange}
            />
            <AnswerTextArea
              defaultValue={props.defaultValue}
              handleOptionChange={props.handleOptionChange}
              placeholder={
                "Please use keywords to describe the image used. E.g.: Dog, 狗 -OR- Red hat, stars, 红色帽子, 星星”"
              }
            />
            {props.type === "MCQ" && (
              <TickComponent checked={props.checked} onClick={props.onClick} />
            )}
          </>
        ) : (
          <>
            <GalleryComponent
              handleOptionFileChange={props.handleOptionFileChange}
            />
            {props.type === "MCQ" && (
              <TickComponent checked={props.checked} onClick={props.onClick} />
            )}
          </>
        )}
      </div>
      {!props.optionFile && (
        <AnswerTextArea
          defaultValue={props.defaultValue}
          handleOptionChange={props.handleOptionChange}
          placeholder={"Type an answer option here..."}
        />
      )}
    </div>
  );
}

// function generatePlaceholder(optionFile: File) {
//     optionFile;
// }

export function GalleryComponent(props: { handleOptionFileChange?: any }) {
  return (
    <label className="cursor-pointer h-full">
      <div className="rounded-md p-1.5 gap-0.5 inline-flex flex-col items-center justify-center bg-brij-Neutral hover:bg-brij-Grey fill-brij-DarkGrey hover:fill-brij-Mud">
        <div className="w-[17px] h-[17px]">
          <IconImage />
        </div>
      </div>
      <input
        type="file"
        id="image_option"
        name="image_option"
        accept="image/png, image/jpeg"
        className="hidden"
        onChange={(e: any) => {
          props.handleOptionFileChange(e.target.files[0]);
        }}
      />
    </label>
  );
}

export function AnswerTextArea(props: {
  handleOptionChange?: any;
  defaultValue?: string;
  placeholder: string;
  value?: string;
}) {
  return (
    <textarea
      placeholder={props.placeholder}
      defaultValue={props.defaultValue}
      value={props.value}
      className="text-xl font-light font-ePanel leading-normal px-4 gap-2.5 w-full h-full border-solid border-2 border-brij-White focus:border-brij-White focus:outline-none bg-transparent resize-none focus:ring-0"
      onChange={(e) => {
        props.handleOptionChange(e.target.value);
      }}
    />
  );
}

interface ICheckIcon {
  checked: boolean;
  onClick: any;
}

function TickComponent(props: ICheckIcon) {
  return (
    <div
      className={`rounded-full p-2 border-solid border-2 gap-2.5 inline-flex flex-col items-center justify-center w-[23px] h-[23px] cursor-pointer
      ${
        props.checked
          ? "stroke-brij-Default border-brij-Blue bg-brij-Blue"
          : "stroke-brij-DarkGrey border-brij-DarkGrey bg-brij-Default"
      }
      `}
      onClick={props.onClick}
    >
      <div className="w-[13px] h-[13px] stroke-[3.5px]">
        <IconTick />
      </div>
    </div>
  );
}
